import script from "./OrderGroupEditModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./OrderGroupEditModal.vue?vue&type=script&setup=true&lang=ts"

import "./OrderGroupEditModal.vue?vue&type=style&index=0&id=54e45072&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e45072"]])

export default __exports__